// extracted by mini-css-extract-plugin
export default {"canceledContainer":"paymentCanceled_canceledContainer__WMGKR","canceled":"paymentCanceled_canceled__Ef9hr"};